import Vue from "vue";
import App from "./App.vue";
//import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Listview from "@laomao800/vue-listview";
import "./style/index.scss";
import VueCookies from "vue-cookies";
import { textFormat } from "@/utils";
import VueVirtualScroller from "vue-virtual-scroller";
Vue.use(VueVirtualScroller);
Vue.use(VueCookies);
Vue.config.productionTip = false;
Vue.use(ElementUI, { size: "mini" });
Vue.use(Listview);
Vue.filter("textFormat", textFormat);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
